import React from "react";
import { render } from "react-dom";
import { Provider } from 'react-redux'

import store from '../project_quote/store'
import App   from "../project_quote/App";

document.addEventListener("DOMContentLoaded", () => {
  if(document.getElementById('quote-form') != null) {
    render(
      <Provider store={store} >
        <App />
      </Provider>,
      document.getElementById('quote-form')
    );
  }
});
